import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { LoaderIcon } from "./LoaderIcon";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Preloader = /*#__PURE__*/memo(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Preloader' : _ref$testName,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'dark' : _ref$color,
    _ref$spaced = _ref.spaced,
    spaced = _ref$spaced === void 0 ? true : _ref$spaced;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('preloader', "preloader--".concat(color), _defineProperty({}, "preloader--space-".concat(size), spaced)),
    "data-component": testName
  }, /*#__PURE__*/React.createElement(LoaderIcon, {
    size: size
  }));
});
Preloader.displayName = Preloader.name;